import swal from 'sweetalert'

import config from '../config'

export default {
    ResHandle,
    ResShowErr,
    ResShowOK,
}

function ResHandle(err, res, cancelCallback, router) {
    if (!err && res.ok) {
        return false
    }

    if (!res) {
        swal({
            title: 'Connection Issue',
            text: 'There is an error with the connection between you and our server, please again try later',
            icon: 'error',
        }).then(() => {
            cancelCallback()
        })
        return true
    }

    var err_str = 'Please check your inputs'

    if (res.body && res.body.error) {
        err_str = res.body.error
    }

    switch (res.status) {
        case 400:
        case 405:
        case 406:
            swal({
                title: 'Invalid request',
                text: err_str,
                icon: 'error',
            }).then(() => {
                cancelCallback()
            })
            return true

        case 401:
            swal({
                title: 'You must be signed in to access this page',
                text: 'Wanna Sign in?',
                icon: 'warning',
                buttons: true,
            }).then((ok) => {
                if (ok) {
                    window.location = config.url_dashboard
                    return
                }

                cancelCallback()
            })
            return true

        case 403:
            swal({
                title: 'You must be signed up to access this page',
                text: 'Wanna Sign up?',
                icon: 'warning',
                buttons: true,
            }).then((ok) => {
                if (ok) {
                    window.location = config.url + '/plans'
                    return
                }

                cancelCallback()
            })
            return true

        case 404:
            swal({
                title: 'Not Found',
                text: 'Please try again later',
                icon: 'error'
            }).then(() => {
                cancelCallback()
            })
            return true

        case 409:
            swal({
                title: 'Seems like you already signed up',
                text: 'Wanna sign in instead?',
                icon: 'warning',
                buttons: true,
            }).then((ok) => {
                if (ok) {
                    window.location = config.url_dashboard
                    return
                }

                cancelCallback()
            })
            return true

        case 423:
            swal({
                title: 'Your subscription is no longer valid',
                text: 'Please subscribe a new plan or check your payment method',
                icon: 'warning',
                buttons: true,
            }).then((ok) => {
                if (ok) {
                    window.location = config.url_dashboard
                    return
                }

                cancelCallback()
            })
            return true

        case 500:
            swal({
                title: 'Server Error',
                text: 'Please try again later',
                icon: 'error'
            }).then(() => {
                cancelCallback()
            })
            return true

        default:
            return false
    }
}

function ResShowErr(text) {
    swal('Error', text, 'error')
}

function ResShowOK(text) {
    swal('Done', text, 'success')
}